import React from "react";
import clsx from "clsx";

import "./BetaBadge.less";

/** Marks a feature still in beta. Spacing is left to where it sits. */
export default function BetaBadge({ className }) {
    return <span className={clsx("beta-badge", className)}>BETA</span>;
}
